import React, { Component, useState, useEffect } from 'react'
import { Error } from '@progress/kendo-react-labels';
import { Switch } from "@progress/kendo-react-inputs";

export function UiSwitch(props) {
    const {
        validationMessage,
        label,
        visited,
        placeholder,
        ischecked,
        handleChange,
        ...others
    } = props;


    return (
        <>
            <div className='sba-telerik-switch'>
                <label className='sba-telerik-label'>{label}</label>
                <Switch onChange={(e) => handleChange(e.target.value)} checked={props.isChecked} />
            </div>

            {visited && validationMessage && <Error>{validationMessage}</Error>}

        </>
    )

}


export function UiSingleSwitch(props) {
    const { name, label, handleChange, checked } = props;

    return (
        <>
            <div className='sba-telerik-switch'>
                <Switch onChange={handleChange} checked={checked} />
            </div>
        </>


    )
}